export default class WebEvaluation1SelectRequest {
  serialNumber;
  listId;
  termId;
  itemId;
  stickerId;
  constructor(data) {
    this.serialNumber = data.serialNumber;
    this.listId = data.listId;
    this.termId = data.termId;
    this.itemId = data.itemId;
    this.stickerId = data.stickerId;
  }
}
